import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'

import Local from '@/plugins/Local'
import Device from '@/plugins/Device'
import Offset from '@/plugins/Offset'
import Hub from '@/plugins/Hub'
import messages from '@/locales'
import Dom3d from '@/plugins/Dom3d'

import AppImage from '@/components/common/AppImage'

window.isFullLoaded = false

Vue.use(Hub)
Vue.use(Local)
Vue.use(Device)
Vue.use(Offset)
Vue.use(Dom3d)

Vue.component('app-image', AppImage)

class vueArtwork {
  constructor () {
    new Vue({
      store,
      router,
      render: h => h(App)
    }).$mount('#app')
  }
}

new vueArtwork()